import * as z from 'zod';

export const GetAccountDetailsRequest = z.object({});
export const GetAccountDetailsResponse = z.object({
  accountDetails: z
    .object({
      status: z
        .enum(['ACTIVE', 'WARNED', 'SUSPENDED', 'BANNED', 'SUSPENDED_AUTOLIFT'])
        .describe('Account status.')
        .optional(),
      package: z
        .object({
          _id: z.string().describe('Package ID.').optional(),
          group: z.string().describe('Package group.').optional(),
          monthlyQuotaAllocation: z
            .object({
              campaigns: z
                .number()
                .int()
                .describe(
                  'Number of allocated marketing campaigns per month (-1 means unlimited).'
                )
                .optional(),
              emails: z
                .number()
                .int()
                .describe('Number of allocated individual emails per month.')
                .optional(),
            })
            .describe('Allocated quota per month.')
            .optional(),
        })
        .describe('Current premium package information.')
        .optional(),
      quotaPeriod: z
        .object({
          dateFrom: z
            .date()
            .describe('Current quota period start date.')
            .optional()
            .nullable(),
          dateTo: z
            .date()
            .describe(
              'Current quota period end date - after which quota will roll over.'
            )
            .optional()
            .nullable(),
          quotaUsage: z
            .object({
              campaigns: z
                .number()
                .int()
                .describe(
                  'Number of allocated marketing campaigns per month (-1 means unlimited).'
                )
                .optional(),
              emails: z
                .number()
                .int()
                .describe('Number of allocated individual emails per month.')
                .optional(),
            })
            .describe(
              'Information about allocated quota already used in this period.'
            )
            .optional(),
        })
        .describe('Quota period and usage.')
        .optional(),
      maxCampaignAudienceSize: z
        .number()
        .int()
        .describe(
          'Max number of recipients for an email marketing campaign. Exceeding this limit may lead to campaigns being rejected.'
        )
        .optional(),
    })
    .describe('Current account details.')
    .optional(),
});
